module.exports = __webpack_public_path__ + "static/img/iv_placeholder_Center@2x.cfd5a120.png";